import {
    GET_EVENT,
    EVENT_LOADING,
    GET_EVENTS,
    EVENTS_LOADING,
    GET_EVENTS_PUBLICS,
    GET_EVENTS_TYPES,
    TAXONOMIES_LOADING,
    SET_EVENTS_SEARCH_CRITERIA,
    RESET_EVENTS_SEARCH_CRITERIA,
    SIGNUP_TO_EVENT,
    SIGNOUT_FROM_EVENT,
    SIGNUPOROUT_TO_EVENT_LOADING,
    SIGNUPOROUT_TO_EVENT_FAILURE,
    DASHBOARD_GET_EVENTS_CHECKEDIN,
    DASHBOARD_GET_EVENTS_AUTHOR,
    DASHBOARD_GET_EVENTS_LOADING,
    SET_CURRENT_USER_SUBSCRIBED,
    TOGGLE_DIALOG_SUBSCRIBE,
    TOGGLE_DIALOG_SUBSCRIBE_SUCCESS,
    TOGGLE_DIALOG_UNSUBSCRIBE,
    TOGGLE_DIALOG_UNSUBSCRIBE_SUCCESS,
    TOGGLE_DIALOG_UPDATE_SUBSCRIBE,
    TOGGLE_DIALOG_UPDATE_SUBSCRIBE_SUCCESS,
    UI_REMEMBER_SCROLL_POSITION_LISTING,
    UI_REMEMBER_PAGINATION_LISTING,
} from './types';

const initialState = {
    event: null,
    eventLoading: false,

    events: [],
    eventsLoading: false,

    publics: [],
    types: [],
    taxonomiesLoading: false,

    hasMore: false,
    currentPage: 1,
    newSearch: false, // Set to TRUE to reinitialize the search results (= fresh/new list)
    fakeLoadingTime: 0,
    search: {
        submitted: false,
        public: '',
        type: '',
    },

    eventSignupOrOut: false,
    eventSignupOrOutLoading: false,
    eventSignupOrOutError: {},

    dashboardEventsCheckedin: [],
    dashboardEventsAuthor: [],
    dashboardEventsLoading: false,

    currentUserSubscribed: false,
    dialogSubscribeOpen: false,
    dialogSubscribeSuccessOpen: false,
    dialogUnsubscribeOpen: false,
    dialogUnsubscribeSuccessOpen: false,
    dialogUpdateSubscribeOpen: false,
    dialogUpdateSubscribeSuccessOpen: false,

    uiRememberScrollPositionListing: 0,
    uiRememberPaginationListing: 1,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case EVENT_LOADING:
            return {
                ...state,
                eventLoading: true
            };
        case EVENTS_LOADING:
            return {
                ...state,
                eventsLoading: true
            };
        case TAXONOMIES_LOADING:
            return {
                ...state,
                taxonomiesLoading: true
            };
        case GET_EVENTS:
            const events = (action.newSearch) ? action.payload.posts : [...state.events, ...action.payload.posts];

            return {
                ...state,
                events: events,
                eventsLoading: false,
                hasMore: action.payload.hasMore,
                currentPage: action.page,
                search: {
                    ...action.search,
                    submitted: false,
                },
                fakeLoadingTime: action.fakeLoadingTime,
            };
        case GET_EVENT:
            return {
                ...state,
                event: action.payload,
                eventLoading: false,
                search: {
                    ...state.search,
                    submitted: true, // Keep search criteria when the user will go back to the events list...
                },
            };
        case GET_EVENTS_PUBLICS:
            return {
                ...state,
                publics: action.payload,
                taxonomiesLoading: false
            };
        case GET_EVENTS_TYPES:
            return {
                ...state,
                types: action.payload,
                taxonomiesLoading: false
            };
        case SET_EVENTS_SEARCH_CRITERIA:
            return {
                ...state,
                search: {
                    submitted: true,
                    public: action.searchTaxonomyPublic,
                    type: action.searchTaxonomyType,
                },
            };
        case RESET_EVENTS_SEARCH_CRITERIA:
            return {
                ...state,
                search: {
                    submitted: false,
                    public: action.searchTaxonomyLevel,
                    type: action.searchTaxonomyLevel,
                },
            };
        case SIGNUP_TO_EVENT:
            return {
                ...state,
                eventSignupOrOutLoading: false,
                eventSignupOrOut: true,
                currentUserSubscribed: true,
            };
        case SIGNOUT_FROM_EVENT:
            return {
                ...state,
                eventSignupOrOutLoading: false,
                eventSignupOrOut: true,
                currentUserSubscribed: false,
            };
        case SIGNUPOROUT_TO_EVENT_LOADING:
            return {
                ...state,
                eventSignupOrOutLoading: true,
                eventSignupOrOutError: {},
                eventSignupOrOut: false,
            };
        case SIGNUPOROUT_TO_EVENT_FAILURE:
            return {
                ...state,
                eventSignupOrOutLoading: false,
                eventSignupOrOutError: action.payload,
                eventSignupOrOut: false,
            };
        case DASHBOARD_GET_EVENTS_CHECKEDIN:
            const eventsCheckedin = (action.newSearch) ? action.payload.posts : [...state.dashboardEventsCheckedin, ...action.payload.posts];

            return {
                ...state,
                dashboardEventsCheckedin: eventsCheckedin,
                dashboardEventsLoading: false,
                hasMore: action.payload.hasMore,
                currentPage: action.page,
                fakeLoadingTime: action.fakeLoadingTime,
            };
        case DASHBOARD_GET_EVENTS_AUTHOR:
            const eventsAuthor = (action.newSearch) ? action.payload.posts : [...state.dashboardEventsAuthor, ...action.payload.posts];

            return {
                ...state,
                dashboardEventsAuthor: eventsAuthor,
                dashboardEventsLoading: false,
                hasMore: action.payload.hasMore,
                currentPage: action.page,
                fakeLoadingTime: action.fakeLoadingTime,
            };
        case DASHBOARD_GET_EVENTS_LOADING:
            return {
                ...state,
                dashboardEventsLoading: true
            };
        case SET_CURRENT_USER_SUBSCRIBED:
            return {
                ...state,
                currentUserSubscribed: action.payload,
            };
        case TOGGLE_DIALOG_SUBSCRIBE:
            return {
                ...state,
                dialogSubscribeOpen: !state.dialogSubscribeOpen
            };
        case TOGGLE_DIALOG_SUBSCRIBE_SUCCESS:
            return {
                ...state,
                dialogSubscribeOpen: false,
                dialogSubscribeSuccessOpen: !state.dialogSubscribeSuccessOpen
            };
        case TOGGLE_DIALOG_UNSUBSCRIBE:
            return {
                ...state,
                dialogUnsubscribeOpen: !state.dialogUnsubscribeOpen
            };
        case TOGGLE_DIALOG_UNSUBSCRIBE_SUCCESS:
            return {
                ...state,
                dialogUnsubscribeOpen: false,
                dialogUnsubscribeSuccessOpen: !state.dialogUnsubscribeSuccessOpen
            };
        case TOGGLE_DIALOG_UPDATE_SUBSCRIBE:
            return {
                ...state,
                dialogUpdateSubscribeOpen: !state.dialogUpdateSubscribeOpen
            };
        case TOGGLE_DIALOG_UPDATE_SUBSCRIBE_SUCCESS:
            return {
                ...state,
                dialogUpdateSubscribeOpen: false,
                dialogUpdateSubscribeSuccessOpen: !state.dialogUpdateSubscribeSuccessOpen
            };
        case UI_REMEMBER_SCROLL_POSITION_LISTING:
            return {
                ...state,
                uiRememberScrollPositionListing: action.payload
            };
        case UI_REMEMBER_PAGINATION_LISTING:
            return {
                ...state,
                uiRememberPaginationListing: action.payload
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/features/Events/reducers.js